import { FrameworkConfiguration } from "aurelia-framework";
import { PLATFORM } from "aurelia-pal";
import { AuthConfig, IAuthConfig } from "./auth-config";
import { AuthService } from "./auth-service";

/**
 * Influenced (aka: "copied and adapted") from: <a href="https://github.com/paulvanbladel/aurelia-auth">
 * Paul van Bladel's <b>aurelia-auth</b> plugin</a>
 */
export function configure(
  frameworkConfiguration: FrameworkConfiguration,
  authConfig: IAuthConfig,
): void {
  frameworkConfiguration.globalResources(
    PLATFORM.moduleName("services/auth/auth-filter"),
  );

  let baseConfig = frameworkConfiguration.aurelia.container.get(AuthConfig);
  baseConfig.configure(authConfig);
}

export { IAuthConfig, AuthService, AuthConfig };
